/**
 * One-time UI flags persisted in localStorage (e.g. "seen the onboarding").
 * Fails safe to `false`/no-op when storage is unavailable (private mode).
 */

export const FLAG_ONBOARDED = "catalogkit.flag.onboarded";
export const FLAG_PRIVACY_TOAST = "catalogkit.flag.privacyToast";

/** Whether a one-time flag has been set. */
export function hasFlag(key: string): boolean {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

/** Set a one-time flag. */
export function setFlag(key: string): void {
  try {
    localStorage.setItem(key, "1");
  } catch {
    // Storage unavailable — ignore.
  }
}
